



















import Vue from "vue";
import * as echarts from "echarts";
import "echarts-liquidfill";
import { getQueryVariable } from "../common/common";
import { mapState, mapActions } from "vuex";
import store from "../store/index";

// // 模板文件不引入echarts
// import config from '../config/index';
// let echarts: any;
// if (config.env !== 'template') {
//   echarts = require('echarts');
//   require('echarts-liquidfill');
// }

export default Vue.extend({
	name: "CheckInfo",
	computed: mapState({
		checkInfo: (state: any) => store.getters.getCheckInfo,
		productId: (state: any) => store.getters.getProductId,
		reportType: (state: any) => store.getters.getReportType,
	}),
	watch: {
		checkInfo(newQuestion, oldQuestion) {
			if (this.productId == "WFWBC") {
				this.checkInfo.reportModel.checkDBIds = [{ checkDBName: "批次互查", status: true }];
			}
		},
	},
	data() {
		return {};
	},
	methods: {
		toPercentageF(val: number) {
			return val.toFixed(4);
		},
		// 获取ProductId reportId
		getProductId() {
			this.$store.dispatch("setProductId", getQueryVariable("productId"));
			this.$store.dispatch("setReportId", getQueryVariable("reportId"));
		},
	},
	created() {
		this.getProductId();
	},
	mounted() {
		if (this.checkInfo.reportModel) {
			if (this.productId == "WFWBC") {
				this.checkInfo.reportModel.checkDBIds = [{ checkDBName: "批次互查", status: true }];
			}
		}
	},
});
